import { REQUEST_LOCALIZE, RequestLocalization } from '@addins/core/core';
import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { TaskTypes } from '@models/imported/SagaBase';
import { Task } from '@models/imported/SagaSchema/Task';
import { UnitActivity } from '@models/imported/SagaSchema/UnitActivity';
import { TaskUnitsProviderService } from '../../services/task-units-provider/task-units-provider.service';

@Component({
  selector: 'app-task-details-item',
  templateUrl: './task-details-item.component.html',
  styleUrls: ['./task-details-item.component.scss']
})
export class TaskDetailsItemComponent implements OnInit {
  @Input()
  task: Task;

  isMonoMission: boolean;

  get units(): UnitActivity[] {
    return this.taskUnitsProvider.units;
  }

  constructor(
    private taskUnitsProvider: TaskUnitsProviderService,
    @Optional()
    @Inject(REQUEST_LOCALIZE)
    private localizer: RequestLocalization
  ) {}

  ngOnInit() {
    this.isMonoMission = this.task.TaskType == TaskTypes.ProjectTask;
  }

  onLocalize() {
    const location = this.task.location;
    this.localizer?.requestLocalize(location.coordinate);
  }
}
